import { PRODUCT_PAGE_SET_SELECTED_VARIANT } from '../constants';

export const setSelectedVariant = (selectedVariant) => ({
  type: PRODUCT_PAGE_SET_SELECTED_VARIANT,
  payload: {
    selectedVariant,
  },
});

export const setProductPageSelectedVariantQuery = (selectedVariant) => {
    const query = new URLSearchParams(window.location.search);
    if (selectedVariant != null) {
      query.set('v', selectedVariant.articleNumber);
    } else {
      query.delete('v');
    }
    const url =
      window.location.href.replace(window.location.search, '') +
      `?${query.toString()}`;
    window.history.pushState('setSelectedVariant', null, url);
  };
